module.exports = __webpack_public_path__ + "media/images/success-check-82cc9580fc7e7415a83f7b82c58aba3e.svg";